import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SignupProcess.css';
import boyImage from './Boy.svg'; // Make sure the image path is correct
import CompanyLogo from './images/CompanyLogo.svg'; // Correct path for the logo

const slogans = [
  "Hello there, superstar! What should we call you? (Your first name, please!)",
  "Awesome, {name}! What's the best email to send you exciting news?",
  "Cool beans, {name}! What's your go-to username? (Make it legendary!)",
  "Almost done, {name}! How can we reach you by phone?",
  "Final step, {name}! Create a super-secure password (no '12345' allowed!)"
];

const SignupProcess = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [userData, setUserData] = useState({
    firstName: '',
    email: '',
    username: '',
    mobile: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const bluePlanetRef = useRef(null);
  const whitePlanetRef = useRef(null);
  const purplePlanetRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const movePlanets = () => {
      const planets = [bluePlanetRef.current, whitePlanetRef.current, purplePlanetRef.current];

      planets.forEach((planet, index) => {
        if (planet) {
          const speed = 0.5 + (index * 0.2);
          const angle = Date.now() * 0.001 * speed;
          const radius = 50 + (index * 20);
          
          const x = Math.cos(angle) * radius;
          const y = Math.sin(angle) * radius;
          
          planet.style.transform = `translate(${x}px, ${y}px)`; // Animate each circle individually
        }
      });
      
      requestAnimationFrame(movePlanets);
    };

    movePlanets();
  }, []);

  const validateForm = (step) => {
    const newErrors = {};
    if (step === 0 && !userData.firstName) {
      newErrors.firstName = 'First name is required';
    } else if (step === 1 && !/\S+@\S+\.\S+/.test(userData.email)) {
      newErrors.email = 'Enter a valid email';
    } else if (step === 2 && !userData.username) {
      newErrors.username = 'Username is required';
    } else if (step === 3 && userData.mobile.length !== 10) {
      newErrors.mobile = 'Mobile number must be 10 digits';
    } else if (step === 4 && userData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters long';
    }
    return newErrors;
  };

  const handleNext = () => {
    const validationErrors = validateForm(currentStep);
    if (Object.keys(validationErrors).length === 0) {
      if (currentStep < 4) {
        setCurrentStep(prevStep => prevStep + 1);
      } else {
        // On the last step, complete the signup and navigate to the login
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
    setErrors({}); // Clear errors on input change
  };

  return (
    <>
      <div className="logo-container">
        <img src={CompanyLogo} alt="Company Logo" />
      </div>

      <div className="signup-process-container">
        <div className="slogan-container">
          {currentStep === 0 ? (
            <span>
              <span className="slogan-initial">H</span>
              <span className="slogan-rest">
                ello there, superstar! What should we call you? (Your first name, please!)
              </span>
            </span>
          ) : (
            <span>{slogans[currentStep].replace('{name}', userData.firstName || 'friend')}</span>
          )}
        </div>

        <div className="signup-box">
          <h1>
            Hey... <span role="img" aria-label="wave">👋</span>
          </h1>

          {currentStep === 0 && (
            <input
              type="text"
              className="signup-form__input"
              name="firstName"
              placeholder="Enter your name"
              value={userData.firstName}
              onChange={handleChange}
            />
          )}
          {errors.firstName && <p className="text-red-500">{errors.firstName}</p>}

          {currentStep === 1 && (
            <input
              type="email"
              className="signup-form__input"
              name="email"
              placeholder="Enter your email"
              value={userData.email}
              onChange={handleChange}
            />
          )}
          {errors.email && <p className="text-red-500">{errors.email}</p>}

          {currentStep === 2 && (
            <input
              type="text"
              className="signup-form__input"
              name="username"
              placeholder="Enter a username"
              value={userData.username}
              onChange={handleChange}
            />
          )}
          {errors.username && <p className="text-red-500">{errors.username}</p>}

          {currentStep === 3 && (
            <input
              type="tel"
              className="signup-form__input"
              name="mobile"
              placeholder="Enter your phone number"
              value={userData.mobile}
              onChange={handleChange}
            />
          )}
          {errors.mobile && <p className="text-red-500">{errors.mobile}</p>}

          {currentStep === 4 && (
            <input
              type="password"
              className="signup-form__input"
              name="password"
              placeholder="Create a password"
              value={userData.password}
              onChange={handleChange}
            />
          )}
          {errors.password && <p className="text-red-500">{errors.password}</p>}

          <button className="signup-form__button" onClick={handleNext}>
            {currentStep === 4 ? 'Finish' : 'Next'}
          </button>
        </div>

        <div ref={bluePlanetRef} className="planet animated-circle blue"></div>
        <div ref={whitePlanetRef} className="planet animated-circle white"></div>
        <div ref={purplePlanetRef} className="planet animated-circle purple"></div>

        <div className="character">
          <img src={boyImage} alt="Boy" />
        </div>
      </div>
    </>
  );
};

export default SignupProcess;
